import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
function SystemAllocationComp() {
  // const [page_Number, setPage_Number] = useState(1);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchbytext, setSearchbytext] = useState("");
  const [deptid, setDeptid] = useState("");
  const [dept, setDept] = useState([]);
  const [error, setError] = useState(null);
  const [allocation, setAllocation] = useState([]);
  const [recordCount, setRecordcount] = useState(0);
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let token = JSON.parse(localStorage.getItem("key"));
  const controller = new AbortController();
  const signal = controller.signal;
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const getDepartment = async () => {
      try {
        const response = await fetch(
          SERVER_URL + `api/common/department_list`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: `bearer ${token.value}`,
            },
            signal: signal,
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setDept(result.result);
      } catch (err) {
        if (err.name === "AbortError") {
          console.log("Fetch request was aborted");
        } else {
          setError(err.message || "An error occurred");
        }
      }
    };

    getDepartment();

    // Cleanup function aborts fetch if component unmounts
    return () => {
      controller.abort();
    };
  }, []); // Empty dependency array to run once on mount

  const [resetTriggered, setResetTriggered] = useState(true);
  const Reset_filter = () => {
    setSearchbytext("");
    setDeptid("");
    setResetTriggered(true);
  };

  useEffect(() => {
    if (resetTriggered) {
      getsystemAllocation("", "", "");
      setResetTriggered(false);
    }
  }, [resetTriggered]);
  const getsystemAllocation = async () => {
    const response = await fetch(
      SERVER_URL +
        `api/it/systemallocation?text=${searchbytext}&&page=${pageNumber}&&deptid=${deptid}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("token.value", data?.result?.data);
        setAllocation(data?.result?.data);
        setRecordcount(data?.result?.totalCount);
      });
  };
  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  };
  function ucwords(str) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const search_filter = () => {
    getsystemAllocation("", "", deptid);
  };
  return (
    <>
      <div id="content_area">
        <div className="page-header">
          <h1>Update Email</h1>
          <ul id="breadcrumbs" className="breadcrumb mb00">
            <li>
              <Link to="/dashboard">Dashboard </Link>
            </li>
            <li className="current">
              <span>/</span> system-allocation
            </li>
          </ul>
        </div>
        <div className="row_bg">
          <div className="dash_white_box2 mb20 p20">
            <div className="dash_white_box_ttl">Search</div>
            <div className="row mb10">
              <div className="col-lg-3 col-md-6 pr07">
                <label className="form-label">Employee Name / Code</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setSearchbytext(e.target.value)}
                  value={searchbytext}
                  autoComplete="none"
                  placeholder="Search by name"
                />
              </div>

              <div className="col-lg-3 col-md-6 pl07 pr07">
                <label className="form-label">Division</label>
                <div className="form-input">
                  <select
                    onChange={(e) => setDeptid(e.target.value)}
                    value={deptid}
                    className="form-select"
                  >
                    <option value="">Select Division </option>
                    {dept?.map((item, ind) => {
                      return (
                        <option key={ind + 1} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 pr07">
                <label className="h49 mb10"></label>
                <button className="btn_5 mr08" onClick={search_filter}>
                  Search
                </button>
                <button className="btn_6" onClick={Reset_filter}>
                  Reset
                </button>
              </div>
            </div>
          </div>
          <div className="row mb30">
            <div className="col-md-12">
              <table className="table_style_1">
                <thead>
                  <tr>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>Division</th>
                    <th>Department </th>
                    {/* <th>Reporting Manager</th> */}
                    {/* <th>Contact No</th> */}
                    <th>System Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {allocation.map((item, ind) => {
                    return (
                      <tr key={ind}>
                        <td>{item.user_code}</td>
                        <td>
                          <span className="avatar_icon">
                            {getInitials(item.name)}
                          </span>{" "}
                          {item.name ? ucwords(item.name) : "N/A"}
                        </td>
                        <td>division</td>
                        <td>{item.dept_name}</td>
                        {/* <td>{item.RPTM}</td> */}
                        {/* <td>{item.contact_no ? item.contact_no : "N/A"}</td> */}
                        <td>
                          {item.system_type == 3
                            ? "Laptop"
                            : item.system_type == 2
                            ? "Desktop"
                            : "N/A"}
                        </td>
                        <td>
                          <Link
                            className="btn_5 mr07"
                            // to={`/system-allocation-view/${item.user_id}`}
                          >
                            View
                          </Link>

                          <Link
                            className="btn_7"
                            to={`/system-allocation-update/${item.user_id}`}
                          >
                            Update
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SystemAllocationComp;
